import React from 'react'
import {useParams, useNavigate} from "react-router-dom";
import InactivityLogout from '../services/InactivityLogout';
import Header from '../components/Header'
import ReportSection from '../components/reportSection';

export default function Reports() {
  
  const {email} = useParams();
  const navigate = useNavigate();

  return (
    <>
        <InactivityLogout>
        <Header searchterm={email} />
        <ReportSection searchterm={email} navigate={navigate}  />
        </InactivityLogout>
    </>
  )
}
